import { render, staticRenderFns } from "./UserChangePasswordOther.vue?vue&type=template&id=04128b36&"
import script from "./UserChangePasswordOther.vue?vue&type=script&lang=js&"
export * from "./UserChangePasswordOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports